import React from 'react';
import { Phone, Mail, Globe } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="relative w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center shadow-lg">
                <Globe className="w-6 h-6 absolute opacity-30 text-white" />
                <span className="relative font-bold text-xs text-white">CACS</span>
              </div>
              <h3 className="font-bold text-lg">Child Advocacy Consulting Services</h3>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Dedicated to protecting children worldwide through expert consultations, 
              training programs, and evidence-based prevention education.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact Us</h4>
            <div className="space-y-3">
              <a 
                href={`tel:${contactInfo.phone}`} 
                className="flex items-center gap-3 text-gray-300 hover:text-white transition-colors"
              >
                <Phone className="w-5 h-5" />
                <span>{contactInfo.phone}</span>
              </a>
              <a 
                href={`mailto:${contactInfo.email}`} 
                className="flex items-center gap-3 text-gray-300 hover:text-white transition-colors"
              >
                <Mail className="w-5 h-5" />
                <span className="text-sm">{contactInfo.email}</span>
              </a>
            </div>
          </div>

          {/* Global Reach */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Global Services</h4>
            <div className="flex items-center gap-3 text-gray-300">
              <Globe className="w-5 h-5" />
              <span>Serving {contactInfo.servingCountries} Countries Worldwide</span>
            </div>
            <p className="text-gray-400 text-sm mt-4">
              We provide child advocacy consulting services across all continents, 
              supporting communities in their mission to protect children.
            </p>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; {currentYear} Child Advocacy Consulting. All rights reserved.</p>
          <p className="mt-2">Committed to child safety and protection worldwide.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
